const PurchaseOrderRoutes = [
  //Purchase Orders
  {
    path: '/purchase-order-menu',
    name: 'purchase-order-menu',
    component: () => import('@/components/orders/PurchaseOrderMenu.vue'),
  },
  {
    path: '/purchase-order-history',
    name: 'purchase-order-history',
    component: () => import('@/components/orders/PurchaseOrderHistory.vue'),
  },
  {
    path: '/purchase-order-invoice',
    name: 'purchase-order-invoice',
    component: () => import('@/components/orders/common/PurchaseOrderInvoice'),
  },

  //Purchase Orders Edit

  {
    path: '/purchase-order-edit',
    name: 'purchase-order-edit',
    component: () => import('@/components/orders/common/PurchaseOrderEdit'),
  },
  {
    path: '/purchase-order',
    name: 'purchase-order',
    component: () => import('@/components/preorder/PurchaseOrder.vue'),
  },

  //Purchase Receipt
  {
    path: '/purchase-receipt',
    name: 'purchase-receipt',
    component: () => import('@/components/preorder/PurchasedReceipt.vue'),
  },

  //Purchase Receipt

  {
    path: '/quick-action-receipt',
    name: 'quick-action-receipt',
    component: () => import('@/components/preorder/QuickActionReceipt.vue'),
  },
];

export default PurchaseOrderRoutes;
